var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.campaigns.length)?_c('SwiperSlider',{attrs:{"type":"recommendations","campaigns":_vm.campaigns,"title":"Recommendations"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }